import React from 'react';
import logo from "../assets/logo.png";
import { ArrowLeft, CheckCircle, Info, Bell, Clock } from "lucide-react";
import '../CSS/notification.css'

function Notification() {
  const notifications = [
    {
      id: 1,
      title: "Registration Confirmed",
      message: "Your appointment has been registered successfully. Token #23 assigned.",
      icon: <CheckCircle size={18} className="notifpage-icon-success" />,
      time: "9/15/2025, 7:30 PM",
    },
    {
      id: 2,
      title: "Chamber Assignment",
      message: "You have been assigned to Chamber #3.",
      icon: <Info size={18} className="notifpage-icon-info" />,
      time: "9/15/2025, 7:30 PM",
    },
    {
      id: 3,
      title: "Queue Update",
      message: "You are next in line! Please be ready to proceed to Chamber #3.",
      icon: <Bell size={18} className="notifpage-icon-alert" />,
      time: "9/15/2025, 7:30 PM",
    },
    {
      id: 4,
      title: "Your Turn Approching",
      message: "You are next in line! Please be ready to proceed to Chamber #3.",
      icon: <Info size={18} className="notifpage-icon-info" />,
      time: "9/15/2025, 7:30 PM",
    },
  ];

  return (
    <div className="notifpage-container">
      {/* ===== Header ===== */}
      <header className="notifpage-header">
        <div className="notifpage-header-left">
          <ArrowLeft size={20} className="notifpage-backicon" />
          <img src={logo} alt="Q-Less Logo" className="notifpage-logo" />
          
        </div>

        <button className="notifpage-markread-btn">Mark All Read</button>
      </header>

      {/* ===== Notification Banner ===== */}
      <div className="notifpage-banner">
        You have 4 unread notifications
      </div>

      {/* ===== Notifications List ===== */}
      <main className="notifpage-main">
        {notifications.map((notif) => (
          <div key={notif.id} className="notifpage-card">
            <div className="notifpage-card-header">
              {notif.icon}
              <div className="notifpage-card-text">
                <h3>{notif.title}</h3>
                <p>{notif.message}</p>
              </div>
            </div>
            <div className="notifpage-time">
              <Clock size={14} />
              <span>{notif.time}</span>
            </div>
          </div>
        ))}
      </main>

      {/* ===== Footer ===== */}
      <footer className="notifpage-footer">
        © 2025 Q-Less. All Rights Reserved.
      </footer>
    </div>
  );
}

export default Notification;